import { heroData } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-950/85 z-[1]"></div>
      <img
        src={heroData.heroImage}
        alt="草民影院主视觉 - 高清流畅追剧体验"
        className="absolute inset-0 w-full h-full object-cover object-top"
        onError={(e) => {
          (e.currentTarget as HTMLImageElement).style.display = 'none';
        }}
      />

      <div className="relative z-[2] w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-500/20 text-primary-400 border border-primary-500/30 mb-5 whitespace-nowrap">
              {heroData.tag}
            </span>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black font-heading text-background-50 leading-tight mb-4">
              {heroData.title}
              <span className="block text-xl md:text-2xl lg:text-3xl font-semibold text-background-200/90 mt-2">
                {heroData.subtitle}
              </span>
            </h1>

            <p className="text-sm md:text-base text-background-300/80 mb-3 font-medium tracking-wide">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-background-300/80 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-black font-heading text-accent-400">
                    {stat.value}
                  </div>
                  <div className="text-xs text-background-300/70 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                className="inline-flex items-center gap-2 px-8 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                {heroData.primaryCta.label}
              </a>
              <a
                href={heroData.secondaryCta.href}
                className="inline-flex items-center gap-2 px-8 py-3 rounded-md border border-background-300/40 hover:border-background-200/80 text-background-200 hover:text-background-50 font-medium text-sm transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg hidden lg:block">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-2xl"></div>
              <img
                src={heroData.heroImage}
                alt="草民影院 - 海量剧集随心看"
                className="relative w-full h-auto rounded-xl object-cover shadow-2xl"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}